<div class="pipeline-workflow-detail">
  <ng-container *ngIf="activeNode && buildCardData() as cardData; else emptyStateTpl">
    <app-pipeline-node-card [data]="cardData"></app-pipeline-node-card>
  </ng-container>

  <ng-template #emptyStateTpl>
    <div class="empty-state" *ngIf="readFlag(emptyState?.visible, true)">
      <div class="empty-state-icon" *ngIf="readFlag(emptyState?.showIcon, true)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="18" height="18" rx="4"/>
          <path d="M9 12h6M12 9v6" stroke-linecap="round"/>
        </svg>
      </div>
      <span>{{ readText(emptyState?.message, 'Hover over a node on the left to see details.') }}</span>
    </div>
  </ng-template>
</div>
